import React from 'react';
import Breadcrumb from '../components/common/Breadcrumb';

const OurStoryPage = () => {
  return (
    <div className="bg-white min-h-screen py-8">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="border-b pb-4 mb-8">
          <Breadcrumb items={[{ label: 'Home', path: '/' }, { label: 'Our Story', path: '/our-story' }]} />
        </div>
        <h1 className="text-3xl font-light text-center text-gray-900 mb-8 tracking-wide">Our Story</h1>
        <div className="space-y-6 text-gray-700 text-base leading-relaxed">
          <p>ArshiVastra was founded with a simple mission: to bring high-quality, stylish fashion to Pakistan at affordable prices.</p>
          <p>What started as a small online store has grown into a trusted brand serving thousands of customers across the country. We believe in offering products that combine elegance, comfort, and durability.</p>
          <p>Every item in our collection is carefully selected to meet the highest standards of quality and design. Our commitment to customer satisfaction and affordable luxury is what sets us apart.</p>
          <p>Thank you for being part of our journey. We look forward to serving you for years to come.</p>
        </div>
      </div>
    </div>
  );
};

export default OurStoryPage;